/**
 * Utility DOM custom methods.
 */
class DOM_Utility {
    /**
     * Create Document Fragment with inner HTML template.
     * @param {String} pTemplate Text HTML Template.
     * @returns {HTMLAllCollection} 
     */
    static createHTMLFromString(pTemplate) {
        let objHTMLDiv = document.createElement('DIV'),
            objHTML = null;
        objHTMLDiv.insertAdjacentHTML('afterbegin', pTemplate);
        if (!!objHTMLDiv.firstElementChild) {
            objHTML = objHTMLDiv.firstElementChild;
        }
        return objHTML;
    }
    /**
     * decode HTML special characters to string
     * @param {String} pStr Encoded HTML string
     * @returns {String} Decoded HTML string
     */
    static decodeHTMLEntities(pStr) {
        if (pStr && typeof pStr === 'string') {
            // strip script/html tags
            pStr = pStr.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
            pStr = pStr.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
            const HTMLDIV = document.createElement('DIV');
            HTMLDIV.innerHTML = pStr;
            pStr = HTMLDIV.textContent;
            HTMLDIV.remove();
        }
        return pStr;
    }
    /**
     * Encode invalid characters
     * @param {String} pStr Original string. 
     * @returns {String} Sanitized string.
     */
    static encodeHTMLEntities(pStr) {
        return pStr
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;')
            .replace(/\//g, '&#x2F;')
            .replace(/\s/g, '&nbsp;')
            .trim();
    }
}
/**
 * several utilities
 */
class Utility {
    /**
     * It combines n functions. It’s a pipe flowing left-to-right, calling each function with the output of the last one.
     * @param  {...Function} fns collection of functions
     * @returns {any} depends the last Fn
     */
    static pipe(...fns) {
        return (x) => fns.reduce((prevValue, currentFn) => currentFn(prevValue), x);
    }
    /**
     * It combines n functions. It’s a pipe flowing right-to-left, calling each function with the output of the last one.
     * @param  {...Function} fns collection of functions
     * @returns {any} depends the last Fn
     */
    static compose(...fns) {
        return (x) => fns.reduceRight((prevValue, currentFn) => currentFn(prevValue), x);
    }
    /**
     * rigt inner join two objects
     * @param {Object} src source object
     * @param {Object} tgt target object
     * @returns {Object} tgt updated target
     */
    static assign(src, tgt) {
        const primitiveType = ['string', 'number', 'boolean'];

        //Assign non valid arrays or objects
        if (primitiveType.some(t => typeof src === t) || tgt === null || tgt === undefined || src === null || src === undefined || typeof src !== typeof tgt) {
            tgt = src;
            return tgt;
        }

        //handle arrays
        if (Array.isArray(src) && Array.isArray(tgt)) {
            src.forEach((ele, ix) => {
                if (primitiveType.some(t => typeof ele === t)) {
                    tgt[ix] = ele
                } else {
                    tgt[ix] = Utility.assign(ele, tgt[ix]);
                }
            });
        }

        //handle objects
        if (typeof src === 'object') {
            for (const key in src) {
                if (tgt.hasOwnProperty(key)) {
                    //assign value
                    if (primitiveType.some(t => typeof src[key] === t)) {
                        tgt[key] = src[key];
                    } else if (Array.isArray(tgt[key]) && Array.isArray(src[key])) {
                        //decompose array
                        src[key].forEach((ele, ix) => {
                            if (primitiveType.some(t => typeof ele === t)) {
                                tgt[key][ix] = ele
                            } else {
                                tgt[key][ix] = Utility.assign(ele, tgt[key][ix]);
                            }
                        });
                    } else {
                        //decompose object
                        tgt[key] = Utility.assign(src[key], tgt[key]);
                    }
                } else {
                    tgt[key] = src[key];
                }
            }
        }
        return tgt;
    }
}
//TODO: create own sanitizer
/**
 * Sanitizer utility
 */
class Sanitizer {

}